<mat-drawer-container autosize>
  <mat-drawer #drawer mode="over" class="shellDrawer">
    <div class="shellDrawer__header">
      <div class="shellDrawer__eyebrow">Навигация CRM</div>
      <div class="shellDrawer__title">Рабочие разделы</div>
    </div>

    <app-link-list
      [links]="navigationLinks"
      variant="drawer"
      [orderTooltip]="orderList"
      (itemNavigate)="closeDrawer()"
    ></app-link-list>
  </mat-drawer>

  <div id="wrapper">
    <app-header
      *ngIf="!isTsdRoute"
      [navigationLinks]="navigationLinks"
      [orderTooltip]="orderList"
      (toggleMenuEvent)="toggleDrawer()"
    ></app-header>

    <ng-container *ngIf="isTsdRoute">
      <button
        type="button"
        mat-icon-button
        class="tsdHeaderHandle"
        [class.tsdHeaderHandle--open]="tsdHeaderOpen"
        [attr.aria-expanded]="tsdHeaderOpen"
        aria-label="Открыть шапку CRM"
        (click)="toggleTsdHeader()"
      >
        <mat-icon>{{ tsdHeaderOpen ? 'close' : 'menu' }}</mat-icon>
      </button>

      <div *ngIf="tsdHeaderOpen" class="tsdHeaderBackdrop" (click)="closeTsdHeader()"></div>

      <div *ngIf="tsdHeaderOpen" class="tsdHeaderPanel">
        <app-header
          [navigationLinks]="navigationLinks"
          [orderTooltip]="orderList"
          (toggleMenuEvent)="toggleDrawer()"
        ></app-header>
      </div>
    </ng-container>

    <section
      *ngIf="activeRingostatCall"
      class="ringostatCallAlert"
      [class.ringostatCallAlert--minimized]="ringostatCallAlertMinimized"
      aria-live="assertive"
      aria-label="Входящий звонок Ringostat"
    >
      <div class="ringostatCallAlert__icon">
        <mat-icon>phone_in_talk</mat-icon>
      </div>

      <div *ngIf="!ringostatCallAlertMinimized" class="ringostatCallAlert__body">
        <div class="ringostatCallAlert__eyebrow">
          <span>Входящий звонок</span>
          <small *ngIf="activeRingostatReceivedAtLabel">{{ activeRingostatReceivedAtLabel }}</small>
        </div>
        <strong>{{ activeRingostatClientLabel }}</strong>
        <span>{{ activeRingostatPhoneLabel || 'Номер не передан' }}</span>
        <span
          *ngIf="activeRingostatOwnerLabel"
          class="ringostatCallAlert__owner"
          [class.ringostatCallAlert__owner--foreign]="isActiveRingostatForeignClient"
        >
          {{ activeRingostatOwnerLabel }}
          <small *ngIf="activeRingostatOwnerReasonLabel"
            >({{ activeRingostatOwnerReasonLabel }})</small
          >
        </span>
      </div>

      <button
        *ngIf="ringostatCallAlertMinimized"
        type="button"
        class="ringostatCallAlert__compact"
        (click)="expandActiveRingostatCall($event)"
      >
        <span>
          <strong>{{ activeRingostatClientLabel }}</strong>
          <small>{{ activeRingostatPhoneLabel || 'Номер не передан' }}</small>
          <small
            *ngIf="activeRingostatOwnerLabel"
            class="ringostatCallAlert__owner"
            [class.ringostatCallAlert__owner--foreign]="isActiveRingostatForeignClient"
          >
            {{ activeRingostatOwnerLabel }}
          </small>
        </span>
      </button>

      <button
        type="button"
        mat-flat-button
        color="primary"
        class="ringostatCallAlert__open"
        [disabled]="!canOpenActiveRingostatClient"
        (click)="openActiveRingostatClient($event)"
      >
        <mat-icon>person_search</mat-icon>
        Открыть клиента
      </button>

      <button
        *ngIf="!ringostatCallAlertMinimized"
        type="button"
        mat-icon-button
        class="ringostatCallAlert__toggle"
        aria-label="Свернуть уведомление о звонке"
        (click)="minimizeActiveRingostatCall($event)"
      >
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>

      <button
        *ngIf="ringostatCallAlertMinimized"
        type="button"
        mat-icon-button
        class="ringostatCallAlert__toggle"
        aria-label="Развернуть уведомление о звонке"
        (click)="expandActiveRingostatCall($event)"
      >
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>

      <button
        type="button"
        mat-icon-button
        class="ringostatCallAlert__close"
        aria-label="Закрыть уведомление о звонке"
        (click)="closeActiveRingostatCall($event)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </section>

    <div
      *ngIf="incomingB2cCallbacks.length || incomingB2cOrders.length"
      class="incomingWorkTray"
      [class.incomingWorkTray--both]="incomingB2cCallbacks.length && incomingB2cOrders.length"
      aria-live="polite"
    >
      <div
        *ngIf="incomingB2cCallbacks.length && incomingB2cOrders.length"
        class="incomingWorkTray__tabs"
        role="group"
        aria-label="Очереди уведомлений"
      >
        <button
          type="button"
          mat-button
          class="incomingWorkTray__tab incomingWorkTray__tab--callbacks"
          [attr.aria-pressed]="incomingWorkTrayTab === 'callbacks'"
          aria-controls="incoming-callbacks"
          (click)="incomingWorkTrayTab = 'callbacks'"
        >
          Перезвоны <span class="incomingWorkTray__count">{{ incomingB2cCallbacks.length }}</span>
        </button>
        <button
          type="button"
          mat-button
          class="incomingWorkTray__tab incomingWorkTray__tab--orders"
          [attr.aria-pressed]="incomingWorkTrayTab === 'orders'"
          aria-controls="incoming-b2c-orders"
          (click)="incomingWorkTrayTab = 'orders'"
        >
          Заказы B2C <span class="incomingWorkTray__count">{{ incomingB2cOrders.length }}</span>
        </button>
        <a mat-icon-button routerLink="/callbacks" aria-label="Журнал перезвонов" matTooltip="Журнал перезвонов">
          <mat-icon>history</mat-icon>
        </a>
      </div>
      <section
        *ngIf="incomingB2cCallbacks.length"
        id="incoming-callbacks"
        class="incomingCallbackTray"
        [class.incomingWorkTray__group--mobileHidden]="incomingWorkTrayTab === 'orders' && incomingB2cOrders.length"
        aria-label="Ожидающие перезвоны"
      >
        <div class="incomingCallbackTray__summary">
          <div>
            <mat-icon>phone_callback</mat-icon>
            <strong>Перезвоны</strong>
            <span class="incomingWorkTray__count">{{ incomingB2cCallbacks.length }}</span>
          </div>
          <a mat-button class="incomingCallbackTray__journal" routerLink="/callbacks">
            Журнал
          </a>
        </div>

        <div
          class="incomingCallbackTray__list"
          tabindex="0"
          role="region"
          aria-label="Карточки перезвонов, прокрутка по горизонтали"
        >
          <article
            class="incomingCallbackCard"
            *ngFor="
              let request of incomingB2cCallbackPreviewItems;
              trackBy: trackIncomingB2cCallback
            "
          >
            <div class="incomingCallbackCard__head">
              <strong>#{{ request.id }}</strong>
              <small>{{ getIncomingB2cCallbackDateLabel(request) }}</small>
            </div>
            <div class="incomingCallbackCard__body">
              <strong [matTooltip]="getIncomingB2cCallbackNameLabel(request)">
                {{ getIncomingB2cCallbackNameLabel(request) }}
              </strong>
              <span class="incomingCallbackCard__phone">
                {{ getIncomingB2cCallbackPhoneLabel(request) }}
              </span>
            </div>
            <div class="incomingCallbackCard__actions">
              <a
                mat-icon-button
                color="primary"
                class="incomingCallbackCard__call"
                [href]="getIncomingB2cCallbackPhoneHref(request)"
                [attr.aria-label]="'Позвонить ' + getIncomingB2cCallbackPhoneLabel(request)"
                matTooltip="Позвонить"
              >
                <mat-icon>phone</mat-icon>
              </a>
              <button
                type="button"
                mat-icon-button
                class="incomingCallbackCard__client"
                [disabled]="!request.client_id"
                matTooltip="Открыть клиента"
                aria-label="Открыть клиента"
                (click)="openIncomingB2cCallbackClient(request, $event)"
              >
                <mat-icon>person_search</mat-icon>
              </button>
              <button
                type="button"
                mat-icon-button
                color="primary"
                class="incomingCallbackCard__done"
                matTooltip="Результат перезвона"
                aria-label="Результат перезвона"
                [disabled]="incomingB2cCallbackBusyById[request.id]"
                (click)="completeIncomingB2cCallback(request, $event)"
              >
                <mat-spinner
                  *ngIf="incomingB2cCallbackBusyById[request.id]"
                  [diameter]="18"
                ></mat-spinner>
                <mat-icon *ngIf="!incomingB2cCallbackBusyById[request.id]">done</mat-icon>
              </button>
            </div>
          </article>

          <div *ngIf="incomingB2cCallbackHiddenCount" class="incomingCallbackMore">
            +{{ incomingB2cCallbackHiddenCount }}
          </div>
        </div>
      </section>

      <section
        *ngIf="incomingB2cOrders.length"
        id="incoming-b2c-orders"
        class="incomingB2cTray"
        [class.incomingWorkTray__group--mobileHidden]="incomingWorkTrayTab === 'callbacks' && incomingB2cCallbacks.length"
        aria-label="Новые заказы B2C без менеджера"
      >
        <div class="incomingB2cTray__summary">
          <div>
            <mat-icon>storefront</mat-icon>
            <strong>Заказы B2C</strong>
            <span class="incomingWorkTray__count">{{ incomingB2cOrders.length }}</span>
          </div>
        </div>

        <div
          class="incomingB2cTray__list"
          tabindex="0"
          role="region"
          aria-label="Карточки новых заказов, прокрутка по горизонтали"
        >
          <article
            class="incomingB2cCard"
            *ngFor="let order of incomingB2cPreviewOrders; trackBy: trackIncomingB2cOrder"
          >
            <div class="incomingB2cCard__head">
              <strong>#{{ order.id }}</strong>
              <small>{{ getIncomingB2cDateLabel(order) }}</small>
            </div>
            <div class="incomingB2cCard__body">
              <strong [matTooltip]="getIncomingB2cClientLabel(order)">
                {{ getIncomingB2cClientLabel(order) }}
              </strong>
              <span>{{ getIncomingB2cPhoneLabel(order) }}</span>
            </div>
            <div class="incomingB2cCard__actions">
              <div class="incomingB2cCard__sum">{{ getIncomingB2cSumLabel(order) }}</div>
              <button
                type="button"
                mat-flat-button
                color="primary"
                class="incomingB2cCard__claim"
                [disabled]="incomingB2cBusyById[order.id]"
                (click)="claimIncomingB2cOrder(order, $event)"
              >
                <mat-spinner
                  *ngIf="incomingB2cBusyById[order.id]"
                  [diameter]="18"
                ></mat-spinner>
                В работу
              </button>
            </div>
          </article>

          <div *ngIf="incomingB2cHiddenCount" class="incomingB2cMore">
            +{{ incomingB2cHiddenCount }}
          </div>
        </div>
      </section>
    </div>

    <div id="routerWrapper" [class.routerWrapper--tsd]="isTsdRoute">
      <router-outlet></router-outlet>
    </div>

  </div>
</mat-drawer-container>
